import { ICustoAdicionar } from "../../../interface/IProcessosCriarLote";
import { ContainerCustos, ChipCusto, LabelCusto, BotaoRemover } from "./style";

interface IProp {
  custos: ICustoAdicionar[];
  onClickRemover: (idDescricao: number, idProcesso: number) => void;
  limiteCaracteres?: number;
  idProcesso: number;
}

export function BotaoRemoverCusto({
  custos,
  onClickRemover,
  limiteCaracteres = 40,
  idProcesso,
}: IProp) {
  const elementos: JSX.Element[] = [];

  let caracteresUsados = 0;
  let ocultos = 0;

  for (let i = 0; i < custos.length; i++) {
    const custo = custos[i];

    const tamanhoCusto = custo.label.length;

    if (caracteresUsados + tamanhoCusto > limiteCaracteres) {
      ocultos = custos.length - i;
      break;
    }

    caracteresUsados += tamanhoCusto;

    elementos.push(
      <ChipCusto key={custo.idDescricao}>
        <LabelCusto>{custo.label}</LabelCusto>
        <BotaoRemover
          onClick={() => onClickRemover(custo.idDescricao, idProcesso)}
        >
          x
        </BotaoRemover>
      </ChipCusto>
    );
  }

  if (ocultos > 0) {
    elementos.push(
      <ChipCusto key="mais">
        <LabelCusto>+{ocultos}</LabelCusto>
      </ChipCusto>
    );
  }

  return <ContainerCustos>{elementos}</ContainerCustos>;
}
